import { PropType, defineComponent, watchEffect } from 'vue'

import { createTimeoutManager } from '../../ts/utils/timeoutUtils'

import { Toast } from '../MsToastManager/MsToastManager.interface'
import MsToastManager from '../MsToastManager/MsToastManager.vue'

export default defineComponent({
    name: 'MsLocalToastManager',
    components: {
        MsToastManager,
    },
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        modelValue: {
            type: Array as PropType<Toast[]>,
            default: (): Toast[] => [],
            required: true,
        },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        let newId = 0
        const timeoutManager = createTimeoutManager()

        watchEffect(() => {
            props.modelValue.forEach((toast) => {
                if (!toast.id) {
                    const id = newId
                    toast.id = id
                    startTimeout(id)
                }
                newId++
            })
            emit('update:modelValue', props.modelValue)
        })

        function removeId(id: number) {
            const updatedToasts = props.modelValue.filter((toast) => toast.id !== id)
            emit('update:modelValue', updatedToasts)
            stopTimeout(id)
        }

        function startTimeout(id: number) {
            timeoutManager.add(
                id,
                setTimeout(() => removeId(id), 5000),
            )
        }

        function stopTimeout(id: number) {
            timeoutManager.remove(id)
        }

        return {
            removeId,
            startTimeout,
            stopTimeout,
        }
    },
})
